import { useState } from 'react'
import { FaCalendarDays } from "react-icons/fa6";
import CreateEventModal from '../Modal/CreateEventModal';
import EventModal from '../Modal/EventModal';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';
import useTitle from '../Hooks/useTitle';

const CreateEvent = () => {
    useTitle('Create Event')
    const { t } = useTranslation('event');
    const [Open, setOpen] = useState(false);
    const [displayModal, setDisplayModal] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleopenevent = () => {
        setOpen(!Open)
        setLoading(false)
    }

    return (
        <>
            <div className="grid gap-6  p-8  py-6  mt-[76px] sm:ml-[300px]">
                <div className="flex justify-between items-center z-[1] gap-2">
                    <span className='font-[600] text-[26px]'>{t("headre")}</span>
                    <button className='bg-[#3686FF] text-white rounded-lg  w-full  max-w-[160px] py-[12px] text-[14px]' onClick={handleopenevent}>{t("btn_create_event")}</button>
                </div>
                {
                    loading ?
                        (
                            <div className="menuitem rounded-[20px]  cursor-pointer w-full ">
                                <div className="div h-[400px] rounded-[20px] flex items-center">

                                    <Skeleton variant="rectangular" width="100%" className="rounded-[20px]" height="100%" />
                                </div>
                                <div className="p-2">

                                    <Skeleton width="70%" height={50} />
                                    <Skeleton width="60%" height={30} />
                                </div>
                            </div>
                        ) :
                        (
                            <div className=" bg-white py-[160px] rounded-2xl  text-center flex flex-col justify-items-center gap-4">
                                <span className='bg-white rounded-full   text-center  mx-auto p-6' style={{ boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px' }}>
                                    <FaCalendarDays fill='#3686ff' size={20} />
                                </span>

                                <div className="text-[20px] font-[600]">{t("create_span")} <span className='text-[#3686FF]'> {t("event_span")}</span></div>
                                <div>
                                    <button type="button" className='bg-[#3686FF] text-white rounded-lg px-[45px] py-[12px] text-[14px]' onClick={handleopenevent}>{t("btn_create")}</button>
                                </div>

                            </div>
                        )
                }

            </div>
            <CreateEventModal
                Open={Open}
                setOpen={setOpen}
            />
            <EventModal
                displayModal={displayModal}
                setDisplayModal={setDisplayModal}
            />
        </>
    )
}

export default CreateEvent  